import moment from "moment";
import { environment } from "../../../../environments/environment";
import { PaymentRequestType } from "./payment-request";

export enum PaymentStatusPSH {
  NEW = "NEW",
  DON = "DON",
  EXP = "EXP",
  ACT = "ACT",
  CAN = "CAN",
  CLO = "CLO",
  ERR = "ERR",
  REV = "REV",
}

export class PaymentRequestPSH { //  implements PaymentRequestType<any> {
  orderId!: string;

  constructor(private request: any) { }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  getDependantValues() {
    return Promise.all(
      [
        Promise.resolve({} as any),
        Promise.resolve({} as any),
      ]
    )
      .then(
        ([subscriptions, profile]) => {
          const pck = subscriptions?.subscriptions?.find((sub: any) => sub.isPrimarySc); // res.subscriptions.find(sub => sub.smartcardNumber === quote.lineItems[0]?.serialNumber);
          if (subscriptions?.subscriptions) {
            this.addValues({
              smartcardNumber: `${pck?.smartcardNumber}`
            })
          }
          if (profile?.surname) {
            this.addValues({
              firstName: profile?.firstName,
              surname: profile?.surname,
            })
          }
          return this;
        }
      );
  }

  toPaymentRequestObject() {
    const { currencyCode, countryName, lang, dueDate, customerNumber, smartcardNumber, amount, firstName, surname, successReturnURL, failureReturnURL } = this.request;
    const today = moment();
    const orderId = `${customerNumber}${Date.now()}`;
    this.orderId = orderId;
    return {
      successUrl: successReturnURL,
      failureUrl: failureReturnURL,
      amountToPay: `${amount}`,
      customerNumber: customerNumber,
      smartcardNumber: smartcardNumber,
      dueDate: dueDate && moment(dueDate).isSameOrAfter(today) ? dueDate : today.toJSON(),
      orderId: orderId,
      firstName: firstName,
      surname: surname,
      country: countryName,
      businessUnit: environment.MAH_API_BUSINESS_UNIT,
      channel: "dstvsa",
      paymentType: "DstvPayment",
      languageCode: lang,
      currency: currencyCode,
    }
  }

  toTokenRequestObject() {
    return this.toPaymentRequestObject()
  }

  handleResponse(response: any) {
    sessionStorage.setItem('dstv-ss.tid', `${response.orderId}:${response.paymentType}`);
    window.location.assign(response.redirectUrl);
    return Promise.resolve(false)
  }
}